import userProfileMyDocumentsTab from './user-profile-my-documents-tab.json';
import updateProofOfAddress from './update-proof-of-address';
import updateBankAccount from './update-bank-account';

export default {
  'user-profile-my-documents-tab': {
    ...userProfileMyDocumentsTab,
    ...updateProofOfAddress,
    ...updateBankAccount,
  },
};
